import { createEndpoints } from '../../_helpers/utile/endpoint.helper';

export const COUPONS_ENDPOINTS = {
  V1: createEndpoints('v1', {
    COUPON_CLASSIFICATIONS: '/coupon-classifications/',
    COUPON_DISCOUNT_TYPES: '/coupon-discount-types/',
    COUPONS: '/coupons/',
    COUPON_DETAIL: (id: number) => `/coupons/${id}/`,
    DELETE_COUPON: '/coupons/delete/',
  }),
} as const;
